import {useI18n} from 'i18n/I18nContext'
import {Pay} from 'organization/Billing/Pay'
import {useOrganizationBilling} from 'organization/Billing/Providers/OrganizationBillingProvider'
import React from 'react'

export default function PayModal() {
  const {payModalOpen, setPayModalOpen} = useOrganizationBilling()
  const {t} = useI18n()

  const handleOpenModal = () => {
    setPayModalOpen(!payModalOpen)
  }

  return (
    <>
      <div
        onClick={handleOpenModal}
        className={`offcanvas__overlay ${payModalOpen ? 'overlay-open' : ''}`}
      ></div>
      <section className={`speaker__popup-area ${payModalOpen ? 'open' : ''}`}>
        <div className="popup__wrapper">
          <div className="popup__title-wrapper">
            <h3 className="popup__title">
              {t('orgEventBilling.payMethodTitle')}
            </h3>
          </div>
          <div className="popup__input-wrapper">{payModalOpen && <Pay />}</div>
        </div>
      </section>
    </>
  )
}
